type MembershipAlertState = {
  slug?: string | null;
  loading: boolean;
  isLoadingCustomer: boolean;
  isCustomerLoggedIn: boolean;
  hasPublicMembershipPlans: boolean;
};

export function shouldAutoOpenMembershipAlert(_state: MembershipAlertState): boolean {
  return false;
}
